<template>
  <li class="p-1">
    <button
      class="inline-flex px-1.5 py-1.5 text-white border-0 rounded focus:outline-none hover:bg-gray-400"
      :class="active ? 'bg-gray-400' : 'bg-gray-800'"
      @click="$emit('clicked')"
    >
      <i class="p-1 fa-fw" :class="icon" />
    </button>
  </li>
</template>

<script>
export default {
  name: 'MapButton',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
